<div class="tracker" *ngIf="mode && milestoneObj">
   <div class="tracker-line">
      <div class="travelled" [style.flex-basis.%]="percent"></div>
      <div class="to-travel" [style.flex-basis.%]="100 - percent"></div>
   </div>

   <div class="timeline-container">
      <div #trigger class="tracker-displays" *ngFor="let p of positions; let i = index"
         (mouseenter)="showTooltip( p, trigger )" (mouseleave)="tooltipRef.detach()">
         <div class="timeline-item" [ngClass]="{
                'timeline-item-first': i === 0,
                'timeline-item-last': i === positions.length - 1
              }">
            <div class="tracker-circle" [class.visited]="current.position > p"></div>
            <ng-container *ngIf="current.position === p; else elseBlock">
               <button mat-button class="tracker-status" color="accent">
                  <mat-icon [svgIcon]="current.icon"></mat-icon>
                  <span class="tracker-label">{{current.label}}</span>
               </button>
               <div class="milestone-display">
                  <span><b>{{displayMilestone( p ).date | date:'M/d/yy'}}</b></span>
               </div>
            </ng-container>
            <ng-template #elseBlock>
               <div class="milestone-display">
                  <span [style.font-weight]="p > current.position ? 'normal' : 'bold'">{{displayMilestone( p ).label}}</span>
                  <span>{{displayMilestone( p ).date | date:'M/d/yy'}}</span>
               </div>
            </ng-template>
         </div>
      </div>
   </div>
</div>
